import { UNIT } from '../../../../../constant'
import { getKgsWeightUtil } from '../../../../../modules/weight/utils/get-kgs'
import { getLbsWeightUtil } from '../../../../../modules/weight/utils/get-lbs'
import { SET_DATA_KEY } from '../../constants'

export function updateWeightUnitSetDataUtil (set, value) {
  const weightUnit = set[SET_DATA_KEY.WEIGHT_UNIT]
  if (weightUnit === value || !weightUnit) {
    return { ...set }
  }
  const updates = {
    ...set,
    [SET_DATA_KEY.WEIGHT_UNIT]: value
  }
  const weight = set[SET_DATA_KEY.WEIGHT]
  if (value === UNIT.IMPERIAL) {
    return {
      ...updates,
      [SET_DATA_KEY.WEIGHT]: Math.round(getLbsWeightUtil(weight))
    }
  }
  return {
    ...updates,
    [SET_DATA_KEY.WEIGHT]: Math.round(getKgsWeightUtil(weight))
  }
}
